import React, { useRef, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import emailjs from "emailjs-com";

const Home = () => {
  const facts = [
    { number: 10, label: "Years of Experienced" },
    { number: 75, label: "Number of Beds" },
    { number: 20, label: "Number of Doctors" },
    { number: 100, label: "Number of Staffs" },
  ];

  const form = useRef();

  const [data, updateData] = useState({
    Name: "",
    Email: "",
    Number: "",
    Subject: "",
    Message: "",
  });
  const { Name, Email, Number, Subject, Message } = data;

  const changeHandler = (e) => {
    updateData({ ...data, [e.target.name]: [e.target.value] });
  };
  const submitHandler = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_d7nkc98",
        "template_dhs0a87",
        e.target,
        "-_ajGXvF0DTOYDkQE"
      )
      .then(
        (result) => {
          alert("message Sent Succesfully");
          updateData({
            Name: "",
            Email: "",
            Number: "",
            Subject: "",
            Message: "",
          });
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <>
      <div id="Topmargin1">
        <Carousel
          className=" homeclass"
          variant="dark"
          controls={false}
          pause={false}
        >
          <Carousel.Item className=" homeclass1">
            <img
              className="d-block w-100"
              src="Home-Page-Slide-1.jpg"
              alt="First slide"
              // style={{animation:'zoom 15s'}}
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="Infertility-2.jpg"
              alt="SECOND slide"
              // style={{animation:'zoom 15s'}}
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="Pulmonology-2.jpg"
              alt="THIRD slide"
            />
          </Carousel.Item>
        </Carousel>
      </div>

      {/* cards  */}
      <div className="container image_cards">
        <div className="row">
          <div className="col-md-4 col-sm-12 cardimages">
            <img src="6565dcf9ce980Pediatric-Pulmonology.jpg" alt=""></img>
          </div>
          {/* <div className='col-md-4 col-sm-12 cardimages' >
            <img src='NTRlogo.png' alt=''></img>
          </div> */}
          <div className="col-md-4 col-sm-12 cardimages">
            <img src="best_gyencology_aruna_hospital.png" alt=""></img>
          </div>
        </div>
      </div>

      {/* doctor content */}

      <div className="container doctor_content">
        <div className="row">
          <div className="col-md-6 col-sm-12 mt-3 mb-3">
            <img src="Banner.jpg" alt=""></img>
          </div>
          <div className="col-md-6 col-sm-12 doctor_content_text mb-2">
            <p>Welcome to Pinnamaneni Hospital</p>
            <h2>Your Trusted Partner in Healthcare</h2>
            <p>
              Effective treatment begins with the right diagnostics. Pinnamaneni
              Hospital is fully equipped with advanced technologies and medical
              devices. Making a dream come true takes effort in the right timing
              and with the right doctors. Pinnamaneni doesn't compromise in
              making those efforts until we see fruitful results using modern
              diagnostics.
            </p>
            <div class="features-grid">
              <div class="feature-box">
                <div class="icon">
                  <img
                    src="png-transparent-computer-icons-medical-bag-medicine-physician-medical-icons-rectangle-logo-grass-thumbnail.png"
                    alt="Health Care"
                  />
                </div>
                <div class="text">
                  <h3>HEALTH CARE</h3>
                  <p>
                    Caring Beyond Limits,
                    <br />
                    Healing with Heart
                  </p>
                </div>
              </div>

              <div class="feature-box">
                <div class="icon">
                  <img src="images.png" alt="Emergency Unit" />
                </div>
                <div class="text">
                  <h3>EMERGENCY UNIT</h3>
                  <p>
                    Swift Care, Compassionate
                    <br />
                    Response
                  </p>
                </div>
              </div>

              <div class="feature-box">
                <div class="icon">
                  <img src="download.png" alt="Lab Test Reports" />
                </div>
                <div class="text">
                  <h3>LAB TEST REPORTS</h3>
                  <p>
                    Precision in Diagnostics,
                    <br />
                    Results with Trust
                  </p>
                </div>
              </div>

              <div class="feature-box">
                <div class="icon">
                  <img
                    src="pngtree-flatstyle-heartbeat-line-with-heart-icon-on-white-background-vector-png-image_41126950.jpg"
                    alt="Qualified Doctors"
                  />
                </div>
                <div class="text">
                  <h3>QUALIFIED DOCTORS</h3>
                  <p>
                    Expertise Beyond Measure,
                    <br />
                    Your Health in Trusted
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* our departments */}
      <div className="container department">
        <h2>Our Departments</h2>
        <p>
          Discover a comprehensive range of healthcare services tailored to meet
          the unique needs of our <br /> patients
        </p>
        <div className="row">
          <div className="col-md-4 department_content mt-4 mb-4">
            <button className="epartment_content_button">
              <a href="">Obstetric & Gynaecology</a>
            </button>
            <button className="epartment_content_button">
              <a href="">Fertility Care</a>
            </button>
            <button className="epartment_content_button">
              <a href="">Pediatric Pulmonologist</a>
            </button>
          </div>
          <div className="col-md-8 department_content_text ">
            <p>
              We truly believe in making the clinic visit a pleasant experience
              for our patients. Our team of doctors and supporting staff make
              sure that we treat our patients well in a caring environment.
            </p>
            <h3>Obstetric & Gynaecology</h3>
            <p>
              We take care of every precaution. Because life’s better when
              you’re covered.
            </p>
            <h3>Fertility Care</h3>
            <p>
              The journey from A to B is inspiring, but the step in between them
              is indispensable.
            </p>
            <h3>Pediatric Pulmonologist</h3>
            <p>
              At Pinnamaneni Hospital, Our Pediatricians provide evidence-based
              preventative and well-child…
            </p>
          </div>
        </div>
      </div>

      {/* two doctors content */}
      <div className="doctor">
        <p>Meet our team</p>
        <h2>Specialist Doctors</h2>
        <div class="container mt-5">
          <div class="row align-items-center mb-5">
            <div class="col-md-6 d-flex align-items-center mb-4">
              <img src="02.jpg" class="doctor-img" alt="Dr. PawanKalyan" />
              <div class="doctor-info ms-4">
                <h4 class="doctor-name">Dr. PawanKalyan</h4>
                <p class="doctor-qual">
                  MD (Ped), FACI Fellow in Pediatric Pulmonary and Sleep
                  Medicine (Aus) Consultant Pulmonary, Allergy and sleep
                  Specialist
                  <br />
                  M.D(Ped)FACI
                </p>
              </div>
            </div>

            <div class="col-md-6 d-flex align-items-center mb-4">
              <img
                src="WhatsApp-Image-2022-06-08-at-3.16.52-PM.jpeg"
                class="doctor-img"
                alt="Dr. G.Sree Lakshmi"
              />
              <div class="doctor-info ms-4">
                <h4 class="doctor-name">Dr. G.Sree Lakshmi</h4>
                <p class="doctor-qual">
                  MBBS, MS(Obg), Fellowship in Reproductive Medicine, Fellowship
                  in Obstetric Ultrasound FMAS, DMAS Consultant Fertility
                  Specialist, Obstetrician and Gynecologist
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* testmonials */}

      <div className="testimonial-section">
        <div className="text-center mb-4">
          <p className="testimonial-title-top">TESTIMONIALS</p>
          <h2 className="testimonial-title-main">Our Patients Says About Us</h2>
        </div>

        <Carousel
          controls={false}
          indicators
          interval={4000}
          pause={false}
          fade={false}
        >
          <Carousel.Item>
            <div className="text-center testimonial-slide">
              <div className="testimonial-icon">❝</div>
              <p className="testimonial-text">
                My experience in this hospital was awesome 👌 the doctor is very
                friendly and patient. He listens to our problem carefully and
                tries to solve it in just 2 or 3 days with a new ideology and
                medicine. I will surely recommend consulting here
              </p>
              <p className="testimonial-name">KOUSHIK yt</p>
              <p className="testimonial-role">Patient</p>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div className="text-center testimonial-slide">
              <div className="testimonial-icon">❝</div>
              <p className="testimonial-text">
                My experience in this hospital was very nice. The doctor Mr.
                Pawan Kalyan & Staff is very friendly and he listens to our
                problem carefully and as per our problem, he’s given perfect
                medicines. I will surely recommend consulting here. Excellent
                service...
              </p>
              <p className="testimonial-name">chandra babu</p>
              <p className="testimonial-role">Patient</p>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div className="text-center testimonial-slide">
              <div className="testimonial-icon">❝</div>
              <p className="testimonial-text">
                Dr. Pawan Kalyan is a very good doctor. He doesn’t prescribe
                unnecessary medicines to babies. He listens to the problem
                carefully and patiently and gives a simple treatment. He is
                always open to queries and he is also friendly with babies. I
                surely recommend him.{" "}
              </p>
              <p className="testimonial-name">Mounica puvvula</p>
              <p className="testimonial-role">Patient</p>
            </div>
          </Carousel.Item>

          {/* Add more Carousel.Item blocks if needed */}
        </Carousel>
      </div>

      {/* appointment and arunhospital facts block */}

      <div className="container-fluid">
        <div className="row">
          <div
            className="col-md-6 mt-2 mb-2"
            style={{ backgroundColor: "#722e85" }}
          >
            <div>
              <p
                style={{
                  fontSize: "5px !important",
                  fontFamily: "Roboto, sans-serif",
                  color: "grey",
                  marginBottom: "5px",
                  textTransform: "uppercase",
                  marginTop: "40px",
                }}
              >
                Consultation
              </p>
              <h1
                style={{
                  fontSize: "23px !important",
                  fontFamily: "Roboto, sans-serif",
                  color: "#b066d4",
                  fontWeight: "bold",
                  marginBottom: "10px",
                }}
              >
                <span style={{ color: "#fff" }}>GET IN TOUCH</span>
              </h1>
              <p
                style={{
                  fontSize: "5px !important",
                  fontFamily: "Roboto, sans-serif",
                  color: "#fff",
                  marginBottom: "5px",
                  marginTop: "30px",
                }}
              >
                Ready to prioritize your health? Book your consultation online
                or call us to schedule an appointment.
              </p>

              {/* form submission .......*/}
              <form ref={form} onSubmit={submitHandler}>
                <div
                  className="container w-100 m-auto p-3 "
                  style={{ borderRadius: "20px" }}
                >
                  <div className="row">
                    <div className="col-lg-6 my-3 ">
                      <div className="form-group ">
                        <input
                          type="text"
                          value={Name}
                          onChange={changeHandler}
                          className="form-control custom-input"
                          title=""
                          placeholder="Your Name"
                          name="Name"
                          required="Username is Required..."
                          message="Username must be atmost 30 characters long..."
                          style={{
                            padding: "10px",
                            backgroundColor: "#722e85",
                            border: "none",
                            borderBottom: "1px solid white",
                          }}
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>
                    <div className="col-lg-6 my-3 ">
                      <div className="form-group">
                        <input
                          type="email"
                          value={Email}
                          onChange={changeHandler}
                          className="form-control custom-input"
                          title=""
                          placeholder="Your Email Address"
                          name="Email"
                          id="email"
                          required="Email is required"
                          data-error="Please enter your email"
                          fdprocessedid="p2hd6j"
                          style={{
                            padding: "10px",
                            backgroundColor: "#722e85",
                            border: "none",
                            borderBottom: "1px solid white",
                          }}
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>
                    <div className="col-lg-6 my-3">
                      <div className="form-group">
                        <input
                          type="text"
                          value={Number}
                          onChange={changeHandler}
                          className="form-control custom-input"
                          title=""
                          name="Number"
                          placeholder="Phone Number"
                          id="phone_number"
                          required="Number is Required"
                          data-error="Please enter your number"
                          fdprocessedid="cf7ig"
                          style={{
                            padding: "10px",
                            backgroundColor: "#722e85",
                            border: "none",
                            borderBottom: "1px solid white",
                          }}
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>
                    <div className="col-lg-6 my-3">
                      <div className="form-group">
                        <input
                          type="text"
                          value={Subject}
                          onChange={changeHandler}
                          className="form-control custom-input"
                          title=""
                          name="Subject"
                          placeholder="Subject"
                          id="msg_subject"
                          required="Subject is Required"
                          data-error="Please enter your subject"
                          fdprocessedid="4mor3e"
                          style={{
                            padding: "10px",
                            backgroundColor: "#722e85",
                            border: "none",
                            borderBottom: "1px solid white",
                          }}
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>
                    <div className="col-lg-12 my-3">
                      <div className="form-group">
                        <textarea
                          name="Message"
                          value={Message}
                          onChange={changeHandler}
                          className="form-control custom-input"
                          id="message"
                          cols="30"
                          rows="2"
                          placeholder="Type Your Message Here"
                          required="Message is required"
                          data-error="Write your message"
                          style={{
                            backgroundColor: "#722e85",
                            border: "none",
                            borderBottom: "1px solid white",
                          }}
                        ></textarea>
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <button
                        type="submit"
                        className="btn "
                        title=""
                        name="contact"
                        style={{
                          backgroundColor: "722e85",
                          color: "white",
                          border: "1px solid white",
                        }}
                      >
                        Send Message
                      </button>
                      <div
                        id="msgSubmit"
                        className="h3 text-center hidden"
                      ></div>
                      <div className="clearfix"></div>
                    </div>
                  </div>
                </div>
              </form>

              {/* MAP....... */}
            </div>
          </div>
          <div className="col-md-6 mt-3 mb-3">
            <div className="facts-section">
              <div className="facts-title">
                ABOUT PINNAMANENI HOSPITAL FACTS
              </div>
              <div className="facts-grid">
                {facts.map((fact, index) => (
                  <div key={index} className="fact-card">
                    <h2 className="fact-number">{fact.number}</h2>
                    <p className="fact-label">{fact.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
